export const Deg = (metric: { fixed: number; skipped: number; errors: number }): number => {
  const total = metric.fixed + metric.skipped + metric.errors;
  const complete = metric.skipped + metric.fixed;

  if (total > 0) {
    return (complete * 360) / total;
  }

  return total;
};

// 0 - 100%
export const BuildColorAndIcon = (degProgressValue: number) => {
  const percent = (degProgressValue / 360) * 100;

  let color = '';
  let label = 'It’s a good start';
  let statusIcon = '';

  if (percent <= 20) {
    color = '#fdb913';
    label = 'It’s a good start';
    statusIcon = `<img src="/editor/static/gemmeter/icons/emoji-one.svg" />`;
  } else if (percent > 20 && percent <= 40) {
    color = '#00C853';
    label = 'It’s a good start';
    statusIcon = `<img src="/editor/static/gemmeter/icons/emoji-two.svg" />`;
  } else if (percent > 40 && percent <= 60) {
    color = '#00C853';
    label = 'Your page is pretty good';
    statusIcon = `<img src="/editor/static/gemmeter/icons/emoji-three.svg" />`;
  } else if (percent > 60 && percent < 100) {
    label = 'Your page is great';
    color = '#00C853';
    statusIcon = `<img src="/editor/static/gemmeter/icons/emoji-four.svg" />`;
  } else if (percent >= 100) {
    color = '#00C853';
    label = 'Your page is nearly perfect';
    statusIcon = `<img src="/editor/static/gemmeter/icons/emoji-five.svg" />`;
  } else {
    color = '#fdb913';
    statusIcon = `<img src="/editor/static/gemmeter/icons/emoji-one.svg" />`;
  }

  const style = {
    '--progress': `${degProgressValue}deg`,
    background: `conic-gradient(${color} var(--progress),#fff 0deg)`,
  };

  return {
    statusIcon,
    label,
    style,
    color,
  };
};
